<template>
  <div class="print-template">
    <el-dialog title="打印模版" :visible.sync="dialogFormVisible" style="padding: 20px;" width="1200px">
      <el-form :inline="true" label-position="left">
        <el-form-item label="模板名称" label-width="100px">
          <el-input maxlength='450' v-model="templateName"></el-input>
        </el-form-item>
      </el-form>
      <div class="choose-size">
        <div class="choose-size-title">选择打印纸张尺寸比例</div>
        <span :class="[{ active: sizeType == 1 }, 'size']" @click="setPage(100, 1)">1:1</span>
        <span :class="[{ active: sizeType == 2 }, 'size']" @click="setPage(60, 2)">5:3</span>
        <span :class="[{ active: sizeType == 4 }, 'size']" @click="setPage(209, 4)">水洗标</span>
        <div class="auto-size">
          自定义尺寸比例(宽：高)：<input type="text" v-model="width" />:<input type="text" v-model="height" />
          <el-button type="primary" @click="setPage((height / width) * 100, 3)">确定</el-button>
        </div>
      </div>
      <div class="add-template">
        <el-button type="primary" @click="add">添加</el-button>
        <!-- <el-button type="primary" @click="print">打印测试</el-button>
        <el-button type="primary" @click="testprint">测测试试</el-button> -->
      </div>
      <div class="draw-content">
        <div class="left-container">
          <div id="templateDesignDiv" />
          <el-button type="primary" @click="savePrint" style="margin-top: 20px">保存视图</el-button>
          <span style="
              color: red;
              line-height: 32px;
              font-size: 12px;
              margin-left: 20px;
            ">*移动完视图,请点击“保存视图”</span>
        </div>
        <div class="right-container">
          <el-empty description="请添加内容！" v-if="templateJson.printElements.length == 0"></el-empty>
          <div v-if="templateJson.printElements.length > 0">
            <div style="text-align: right; padding: 10px">
              <el-button type="primary" @click="draw" size="mini">保存</el-button>
            </div>
            <el-collapse accordion>
              <el-collapse-item :name="index" v-for="(item, index) in templateJson.printElements" :key="index"
                :title="'内容' + (index + 1)">
                <el-form :inline="true" class="demo-form-inline">
                  <el-form-item label="标题">
                    <el-input maxlength='450' v-model="item.options.title" placeholder="请填写" controls-position="right">
                    </el-input>
                  </el-form-item>
                  <!-- <el-form-item label="字段名称">
                    <el-input maxlength='450' v-model="item.options.field" placeholder="请填写"></el-input>
                  </el-form-item> -->
                  <el-form-item label="字段名称">
                    <el-select v-model="item.options.field">
                      <el-option :label="item.label" :value="item.value" v-for="item in printContentList"
                        :key="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="预览文本">
                    <el-input maxlength='450' v-model="item.options.testData" placeholder="请填写"
                      controls-position="right"></el-input>
                  </el-form-item>
                  <el-form-item label="条形码格式" v-if="item.options.textType === 'barcode'">
                    <el-select v-model="item.options.barcodeMode">
                      <el-option :value="undefined" label="默认">默认</el-option>
                      <el-option value="CODE39" label="CODE39">CODE39</el-option>
                    </el-select>
                  </el-form-item>
                  <br />
                  <el-form-item label="字体大小">
                    <el-input maxlength='450' v-model="item.options.fontSize" placeholder="请填写"
                      controls-position="right"></el-input>
                  </el-form-item>
                  <el-form-item label="行高">
                    <el-input maxlength='450' v-model="item.options.lineHeight" placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="字重">
                    <el-input maxlength='450' v-model="item.options.fontWeight" placeholder="请填写"></el-input>
                  </el-form-item>
                  <br />
                  <el-form-item label="宽">
                    <el-input-number v-model="item.options.width" placeholder="请填写宽度" controls-position="right">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="高">
                    <el-input-number v-model="item.options.height" placeholder="请填写高度" controls-position="right">
                    </el-input-number>
                  </el-form-item>
                  <br />
                  <el-form-item label="旋转">
                    <el-input maxlength='450' v-model="item.options.transform" placeholder="请填写"></el-input>
                  </el-form-item>
                  <br />
                  <el-form-item label="距离顶部距离">
                    <el-input-number v-model="item.options.top" placeholder="请填写" controls-position="right">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="距离右侧距离">
                    <el-input-number v-model="item.options.left" placeholder="请填写" controls-position="right">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="文本排列方式">
                    <el-radio v-model="item.options.textAlign" label="left">左对齐</el-radio>
                    <el-radio v-model="item.options.textAlign" label="center">居中</el-radio>
                    <el-radio v-model="item.options.textAlign" label="right">右对齐</el-radio>
                  </el-form-item>
                  <br />
                  <el-form-item label="是否隐藏标题">
                    <el-radio v-model="item.options.hideTitle" :label="true">是</el-radio>
                    <el-radio v-model="item.options.hideTitle" :label="false">否</el-radio>
                  </el-form-item>
                  <el-form-item label="是否隐藏标题">
                    <el-button @click="delOptionsItem(index)">删除</el-button>
                  </el-form-item>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <el-form :inline="true" label-position="left">
        <el-form-item label="模板类型" label-width="100px">
          <el-radio v-model="templateType" :label="1">批次包</el-radio>
          <el-radio v-model="templateType" :label="2">发货打标</el-radio>
          <el-radio v-model="templateType" :label="3">物流</el-radio>
          <el-radio v-model="templateType" :label="4">箱唛</el-radio>
          <el-radio v-model="templateType" :label="5">拣货单</el-radio>
          <!-- <el-radio v-model="templateType" :label="6">水洗标</el-radio> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">保存模版</el-button>
      </div>
    </el-dialog>
    <ChooseConent @submit="addSubmit" ref="chooseContent" />
  </div>
</template>
<script>
import ChooseConent from "./components/chooseContent";
import {
  templateJSON,
  hanlePrintElementsStyle,
  printHtml,
  print,
  getHtml,
} from "./index.js";
import { setTimeout, setInterval } from "timers";
import { printContentList } from "@/utils/print";
import testpic from "@/assets/test.png";
let timer = null;
export default {
  name: "printTemplate",
  components: {
    ChooseConent,
  },
  props: {
    json: {
      type: Object,
      default: () => {
        return {
          index: 0,
          height: 99,
          width: 100,
          printElements: [],
          paperNumberDisabled: true,
          rotate: true,
        };
      },
    },
  },
  watch: {
    json: {
      handler(newValue) {
        if (newValue.panels) {
          let newObj = JSON.parse(JSON.stringify(newValue));
          newObj.panels[0].printElements = hanlePrintElementsStyle(
            newObj.panels[0].printElements
          );
          this.templateJson = newObj.panels[0];
        } else {
          this.templateJson = {
            index: 0,
            height: 99,
            width: 100,
            printElements: [],
            paperNumberDisabled: true,
            rotate: true,
          };
        }
        // console.log(newValue);
      },
      immediate: true,
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      sizeType: 1, //1 =1:1        2 =5:3            3=自定义
      width: "",
      height: "",
      templateJson: {
        index: 0,
        height: 99,
        width: 100,
        printElements: [],
        paperNumberDisabled: true,
        rotate: true,
      },
      templateName: "",
      isEdit: false,
      templateName: "",
      templateType: 0,
      printContentList,
    };
  },
  methods: {
    add() {
      this.$refs.chooseContent.dialogVisible = true;
    },
    addSubmit(obj, name) {
      console.log(obj)
      this.templateJson.printElements.push(obj);
      this.draw();
    },
    //打印
    print() {
      // printHtml(this.hiprintTemplate, [{},{}]);
      // this.hiprintTemplate.print({});
      let templateJsonCache = this.hiprintTemplate.getJson();
      templateJsonCache.panels[0].printElements.push({
        options: {
          left: 58,
          top: 200,
          height: 50,
          width: 50,
          src: testpic,
          styler: function () {
            return {
              "transform": "rotate(180deg)",
              "object-fit": "contain"
            };
          },
        },
        printElementType: {
          title: "图片",
          type: "image",
        },
      });
      print(templateJsonCache || this.hiprintTemplate.getJson(), [
        {
          productName: "手動バルブ水洗标日文",
          shopProductSku: "S22050702000016",
          test1: "M",
          test2: "棉100％",
          companyName: '1',
          companyAddress: "111"
        },
      ]);
    },
    //打印
    testprint() {
      print({
        panels: [
          {
            index: 0,
            height: 80,
            width: 30,
            paperHeader: 0,
            // paperFooter: 283.46456692913387,
            printElements: [
              {
                options: {
                  left: 0,
                  top: 10,
                  width: 80,
                  title: "水洗标",
                  fontFamily: "Microsoft Yahei",
                  fontSize: "7",
                  fontWeight: "normal",
                  color: "#000",
                  lineHeight: 8,
                  textType: "text",
                  textAlign: "left",
                  hideTitle: false,
                  transform: "0",
                  testData: "123456",
                },
                printElementType: { title: "文本", type: "text" },
              },
              {
                options: {
                  left: 0,
                  top: 30,
                  width: 80,
                  title: "色物の場合は、洗濯時に多少色落ちする こ",
                  fontFamily: "Microsoft Yahei",
                  fontSize: 2,
                  fontWeight: "normal",
                  color: "#000",
                  lineHeight: 8,
                  textType: "text",
                  textAlign: "left",
                  hideTitle: false,
                  transform: "0",
                  testData: "",
                  styler: function () {
                    return {
                      fontSize: 4,
                      // transform: "scale(0.5)"
                    };
                  },
                },
                printElementType: { title: "文本", type: "text" },
              },
              {
                options: {
                  left: 0,
                  top: 0,
                  height: 210,
                  width: 80,
                  src: "https://cbu01.alicdn.com/img/ibank/O1CN01eeh2PC1fEb6K0UKkv_!!2200756403975-0-cib.jpg",
                },
                printElementType: {
                  title: "图片",
                  type: "image",
                },
              },
            ],
            paperNumberDisabled: true,
            rotate: true,
          },
        ],
      });

      return;
      // print(this.hiprintTemplate.getJson(), []);
      // printHtml(this.hiprintTemplate, [{},{}]);
      this.hiprintTemplate.print(this.hiprintTemplate, [
        { pkgCode: "10086754" },
      ]);
    },
    //绘制 &重绘
    draw() {
      // console.log(this.templateJson);
      $("#templateDesignDiv").html("");
      console.log("this.templateJson")
      console.log(this.templateJson)
      this.hiprintTemplate = new hiprint.PrintTemplate({
        template: {
          panels: [this.templateJson],
        },
      });
      this.hiprintTemplate.design("#templateDesignDiv");
    },
    //修改图片尺寸
    setPage(height, type) {
      if (type == 4) {
        this.hiprintTemplate.setPaper(60, height - 1);
      } else {
        this.hiprintTemplate.setPaper(100, height - 1);
      }
      // if (type == 4) {
      //   this.hiprintTemplate.setPaper(30, 91);
      //   (this.templateJson.height = 91), (this.templateJson.width = 30);
      // } else {
      //   this.hiprintTemplate.setPaper(100, height - 1);
      //   (this.templateJson.height = 99), (this.templateJson.width = 100);
      // }
      this.templateJson.height = height - 1;
      this.sizeType = type;
    },
    //保存视图
    savePrint() {
      let jsonStr = this.hiprintTemplate.getJson().panels[0];
      jsonStr.printElements = hanlePrintElementsStyle(jsonStr.printElements);
      this.templateJson = jsonStr;
      //循环从templateJson中取出字段，生成一个默认数据Obj，getHtml的时候传入Obj
      //生成一个显示的模板
      let templateObj = {};
      this.templateJson.printElements.forEach((item) => {
        let content = item.options.testData
          ? item.options.testData
          : item.options.textType == "barcode"
            ? "123456789"
            : "示例文字";
        templateObj[item.options.field] = content;
      });
      this.templateObj = templateObj;
    },
    save() {
      //保存前先保存右侧修改信息
      // this.savePrint()
      // this.draw();
      this.savePrint();
      setTimeout(() => {
        let params = {
          templateJson: JSON.stringify(this.hiprintTemplate.getJson()),
          templateHtml: getHtml(this.hiprintTemplate, this.templateObj),
          templateType: this.templateType,
          templateName: this.templateName,
        };
        if (this.isEdit) {
          params = {
            ...this.isEdit,
          };
          params.templateJson = JSON.stringify(this.hiprintTemplate.getJson());
          params.templateHtml = getHtml(this.hiprintTemplate, this.templateObj);
          params.templateType = this.templateType;
          params.templateName = this.templateName;
        }
        this.$emit("submit", params);
      }, 300);
    },
    delOptionsItem(index) {
      // console.log(index);
      this.templateJson.printElements.splice(index, 1);
      this.draw();
    },
  },
  mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.draw();
    });
  },
  destroyed() { },
};
</script>
<style lang="less" scoped>
.print-template {
  text-align: left;

  .choose-size {
    text-align: left;
    margin-bottom: 20px;

    .choose-size-title {
      font-weight: 800;
      font-size: 20px;
      margin-bottom: 10px;
    }

    .size {
      width: 120px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-weight: 600;
      border: 1px solid #f2f2f2;
      display: inline-block;
      border-radius: 4px;
      margin-right: 20px;
      cursor: pointer;

      &.active {
        border-color: #40a9ff;
        color: #40a9ff;
      }
    }

    .auto-size {
      line-height: 32px;
      display: inline-block;

      input {
        width: 50px;
        height: 26px;
        border: 1px solid #f2f2f2;
        margin: 0 4px;
      }
    }
  }

  .add-template {
    margin-bottom: 60px;
  }

  .draw-content {
    display: flex;
    justify-content: space-around;

    .left-container {
      width: 500px;
    }

    .right-container {
      flex: 1;
    }
  }
}

.flex-space {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
